



















































































































import { Component, Vue } from 'vue-property-decorator';
import { TrackShare } from '@/types';
import { TrackShareService } from '@/api';
import { ValidationFails } from '@/api/api';
import UButton from '@/ui-lib/button/Button.vue';
import UTextField from '@/ui-lib/text-field/TextField.vue';
import UAlert from '@/ui-lib/alert/Alert.vue';

export type TrackShareCreateModalParams = {
  trackIDs: number[];
  onCreated?: (trackShare: TrackShare) => void;
};

@Component({
  components: {
    UButton,
    UTextField,
    UAlert
  }
})
export default class extends Vue {
  private trackIDs: number[] = [];
  private onCreated: (trackShare: TrackShare) => void = () => {
    return;
  };
  private name = '';
  private fails: ValidationFails = {};
  private isLoading = false;
  private trackShare: TrackShare | null = null;
  private isCopied = false;

  private close(): void {
    this.$modal.hide('track-share-create');
  }

  private beforeOpen({ params }: { params: TrackShareCreateModalParams }) {
    // A copy: the caller's selection may change while the window is open.
    this.trackIDs = [...(params?.trackIDs || [])];
    this.onCreated =
      params?.onCreated ||
      (() => {
        return;
      });
    this.name = '';
    this.fails = {};
    this.isLoading = false;
    this.trackShare = null;
    this.isCopied = false;
  }

  private focusName() {
    const input = (this.$refs.nameField as HTMLElement | undefined)?.querySelector('input');

    if (input) {
      input.focus();
    }
  }

  private async create() {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;

    try {
      this.trackShare = await TrackShareService.create(this.name, this.trackIDs);
      this.fails = {};
      this.onCreated(this.trackShare);
    } catch (e) {
      this.fails = e?.validationFails || {};

      if (!e?.validationFails) {
        this.$notify({ type: 'error', title: 'Ошибка', text: e?.message || 'Неизвестная ошибка' });
      }
    }

    this.isLoading = false;
  }

  // Copying is a separate click on purpose: Safari refuses clipboard writes that
  // happen after an await, so copying right after creation would silently fail.
  private async copyURL() {
    if (!this.trackShare) {
      return;
    }

    try {
      await navigator.clipboard.writeText(this.trackShare.url);
      this.isCopied = true;
    } catch (e) {
      (this.$refs.urlInput as HTMLInputElement | undefined)?.select();
      this.$notify({
        type: 'warn',
        title: 'Не получилось скопировать',
        text: 'Ссылка выделена, скопируйте её вручную'
      });
    }
  }
}
